import Head from "next/head";
import { SmartLink } from "@/src/components/v2/SmartLink/SmartLink";
import { Utils } from "@/src/Utils";

export interface IBreadCrumb {
    text: string;
    url: string;
    isActive: boolean;
}

const BreadCrumb = ({ crumb }: { crumb: IBreadCrumb }) => {
    const { text, url, isActive } = crumb;

    return (
        <>
            <li className="Breadcrumb text-accent-secondary-ada last:text-text-primary-ada">
                <SmartLink href={url} className="no-underline">
                    <span>{text}</span>
                </SmartLink>
            </li>
            {!isActive && <li className="Breadcrumb text-accent-secondary-ada last:text-text-primary-ada">/</li>}
        </>
    );
};

interface BreadcrumbsProps {
    crumbs: IBreadCrumb[];
}

const Breadcrumbs = ({ crumbs }: BreadcrumbsProps) => {
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: crumbs.map((crumb, index) => ({
            "@type": "ListItem",
            position: index + 1,
            name: crumb.text,
            item: Utils.normalizeURL(crumb.url, true).normalizedURL
        }))
    };

    return (
        <>
            <Head>
                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }} />
            </Head>
            <nav aria-label="Breadcrumb" className="Breadcrumbs flex flex-wrap gap-2 py-3 text-body2 font-bold tracking-body2 text-accent-contrast">
                <ul className="flex flex-wrap gap-2 text-body2 font-bold tracking-body2">
                    {crumbs.map((crumb, index) => (
                        <BreadCrumb key={`${crumb.text}-${index}`} crumb={crumb} />
                    ))}
                </ul>
            </nav>
        </>
    );
};

export default Breadcrumbs;
